import type {
    AssignmentType,
    ManagerPriorityGroup,
} from '../types/orgHierarchy'

/**
 * Format assignment type for display
 */
export const formatAssignmentType = (type: AssignmentType): string => {
    const typeMap: Record<AssignmentType, string> = {
        PRIMARY: 'Primary',
        SECONDARY: 'Secondary',
        MATRIX: 'Matrix',
        INTERIM: 'Interim'
    }
    return typeMap[type] || type
}


/**
 * Format manager priority group for display
 */
export const formatManagerPriorityGroup = (priority: ManagerPriorityGroup): string => {
    const priorityMap: Record<ManagerPriorityGroup, string> = {
        1: 'Same Unit',
        2: 'Parent Unit',
        3: 'Ancestor Units',
        4: 'Other Employees',
    }
    return priorityMap[priority] || 'Unknown'
}

/**
 * Get full name from first and last name
 */
export const getFullName = (firstName: string | null, lastName: string | null): string => {
    const parts = [firstName, lastName].filter(Boolean)
    return parts.join(' ') || 'Unknown'
}
